import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';
import CardLight from 'components/CardLight';
import { DatesSetArg, EventSourceInput } from '@fullcalendar/core';
import { EventProps } from 'types/Event';

type RelevantEventsCardProps = {
  data?: EventSourceInput;
  fullHeight?: boolean;
  onDateChange?: ( args: DatesSetArg ) => void;
  onEventClick?: ( data: EventProps ) => void;
};

function RelevantEventsCard( {
  data, fullHeight,
  onDateChange, onEventClick,
}: RelevantEventsCardProps ) {
  return (
    <CardLight title="Eventos relevantes" fullHeight={fullHeight}>
      <div className="calendar-sm">
        <FullCalendar
          height={410}
          plugins={[dayGridPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            start: 'prev',
            center: 'title',
            end: 'next',
          }}
          locale={esLocale}
          events={data}
          datesSet={( args ) => {
            if ( onDateChange ) onDateChange( args );
          }}
          eventClick={( info ) => {
            if ( onEventClick ) onEventClick( info.event.extendedProps as EventProps );
          }}
        />
      </div>
    </CardLight>
  );
}

export default RelevantEventsCard;
